import { makePieActionObjs } from "shared/imports/pieActionGenerators"

const patchDataDescriptionObjs = makePieActionObjs("patch", "data_description")
export const patchDataDescriptionDict = patchDataDescriptionObjs.pieDict

const postDataDescriptionObjs = makePieActionObjs("post", "data_description")
export const postDataDescriptionDict = postDataDescriptionObjs.pieDict

const getDataDescriptionObjs = makePieActionObjs("get", "data_description")
export const getDataDescriptionDict = getDataDescriptionObjs.pieDict

const ActionTypes = {
    LOADED_DESCRIPTION: "LOADED_DESCRIPTION",
    EDIT_DESCRIPTION: "EDIT_DESCRIPTION",
    CANCEL_EDIT_DESCRIPTION: "CANCEL_EDIT_DESCRIPTION",
    UPDATE_DESCRIPTION: "UPDATE_DESCRIPTION",
    UPDATE_DESCRIPTION_MOBILE: "UPDATE_DESCRIPTION_MOBILE",
    LOAD_DESCRIPTION_START: "LOAD_DESCRIPTION_START",
    UPDATE_TAG_DICT: "UPDATE_TAG_DICT",
    SET_CURRENT_TAB: "SET_CURRENT_TAB",
    SET_TITLE_IS_TRUNCATED: "SET_TITLE_IS_TRUNCATED",

    ...patchDataDescriptionObjs.actionTypes,
    ...postDataDescriptionObjs.actionTypes,
    ...getDataDescriptionObjs.actionTypes,
}

export default ActionTypes
